"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("rxjs/add/operator/map");
require("rxjs/add/operator/filter");
require("rxjs/add/operator/skip");
require("rxjs/add/operator/take");
require("rxjs/add/operator/catch");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
var language_impl_1 = require("../model/language-impl");
var http_1 = require("@angular/common/http");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var Observable_1 = require("rxjs/Observable");
/**
 * Dummy implementation of LanguageService
 * @author gnuni.gevorgyan
 */
var DummyLanguageService = /** @class */ (function () {
    function DummyLanguageService(http, applicationPropertiesService) {
        var _this = this;
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.languages = new ReplaySubject_1.ReplaySubject(1);
        this.languagesApiUrlKey = 'languages-service-url';
        this.applicationPropertiesService
            .getProperty(this.languagesApiUrlKey)
            .then(function (url) { return _this.loadLanguages(url); })
            .catch(DummyLanguageService_1.handleError);
    }
    DummyLanguageService_1 = DummyLanguageService;
    DummyLanguageService.prototype.getAvailableLanguages = function () {
        return this.languages;
    };
    DummyLanguageService.prototype.getInputLanguages = function () {
        return this.languages
            .map(function (languages) {
            var inputLanguages = [];
            for (var i = 0; i < languages.length; i++) {
                var currentLanguage = languages[i];
                if (currentLanguage.getIsInput()) {
                    inputLanguages.push(currentLanguage);
                }
            }
            return inputLanguages;
        });
    };
    DummyLanguageService.prototype.getLanguage = function (id) {
        return this.languages
            .map(function (languages) {
            return languages.find(function (language) { return language.getId() === id; });
        });
    };
    DummyLanguageService.prototype.getDefaultLanguage = function () {
        return this.languages
            .map(function (languages) { return languages[0]; })
            .catch(DummyLanguageService_1.handleError);
    };
    /**
     * Loads all languages from server or from local json file
     */
    DummyLanguageService.prototype.loadLanguages = function (languagesApiUrl) {
        var _this = this;
        var dataPromise = this.http.get(languagesApiUrl).toPromise();
        dataPromise.then(function (res) {
            var languages = [];
            _this.extractLanguages(res).forEach(function (language) {
                languages.push(language);
            });
            _this.languages.next(languages);
        }).catch(DummyLanguageService_1.handleError);
    };
    /**
     * Extracts languages from response
     * @param data Response
     * @returns {Array<Language>} languages as objects
     */
    DummyLanguageService.prototype.extractLanguages = function (data) {
        return data.reduce(function (acc, item) {
            var id = Number(item.id);
            var abbreviation = item.abbreviation;
            var isDefault = Boolean(item.isDefault);
            var direction = item.isRtl ? idm_crosscutting_concepts_frontend_1.LanguageDirection.RTL : idm_crosscutting_concepts_frontend_1.LanguageDirection.LTR;
            var charset = item.charset;
            var alias = new idm_crosscutting_concepts_frontend_1.MultilingualString(DummyLanguageService_1.convertObjectToMap(item.alias));
            var acronym = new idm_crosscutting_concepts_frontend_1.MultilingualString(DummyLanguageService_1.convertObjectToMap(item.acronym));
            var isInput = Boolean(item.isInput !== undefined ? item.isInput : true);
            var language = new language_impl_1.LanguageImpl(id, abbreviation, isDefault, direction, charset, alias, acronym, isInput);
            acc.push(language);
            return acc;
        }, []);
    };
    /**
     * Converts Object to Map
     * @param obj
     * @returns {Map<number, string>}
     */
    DummyLanguageService.convertObjectToMap = function (obj) {
        var strMap = new Map();
        for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
            var k = _a[_i];
            strMap.set(Number(k), obj[k]);
        }
        return strMap;
    };
    /**
     * Handle errors
     * @param error
     * @returns {ErrorObservable}
     */
    DummyLanguageService.handleError = function (error) {
        var errMsg = (error.message) ? error.message :
            error.status ? error.status + " - " + error.statusText : 'Server error';
        console.error(errMsg);
        return Observable_1.Observable.throw(errMsg);
    };
    DummyLanguageService = DummyLanguageService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient, idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], DummyLanguageService);
    return DummyLanguageService;
    var DummyLanguageService_1;
}());
exports.DummyLanguageService = DummyLanguageService;
//# sourceMappingURL=dummy-language.service.js.map